import { render, staticRenderFns } from "./PreviewTable.vue?vue&type=template&id=f2cce4bc"
import script from "./PreviewTable.vue?vue&type=script&lang=js"
export * from "./PreviewTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports